import { render, staticRenderFns } from "./InputKey.vue?vue&type=template&id=bf818f26&scoped=true"
import script from "./InputKey.vue?vue&type=script&lang=js"
export * from "./InputKey.vue?vue&type=script&lang=js"
import style0 from "./InputKey.vue?vue&type=style&index=0&id=bf818f26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf818f26",
  null
  
)

export default component.exports